import { useDispatch } from "react-redux";
import {
  setLackOfReconciliationFilter,
  setLackOfReconciliationActiveTab,
  setLackOfReconciliationDateRange,
} from "..";

export const useFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setLackOfReconciliationFilter({ key, value }));

  const updateActiveTab = (tab: "lack" | "status-grid") =>
    dispatch(setLackOfReconciliationActiveTab(tab));

  const updateDateRange = (range: { from: string | null; to: string | null }) =>
    dispatch(setLackOfReconciliationDateRange(range));

  return { updateFilter, updateActiveTab, updateDateRange };
};
